// MUTATIONS
export const SET_IS_MODAL_VISIBLE = 'setIsModalVisible';
export const SET_SELECTED_USER = 'setSelectedUser';
export const SET_IS_LOADING = 'isLoading';
export const SET_IS_ACTIVE_REQUEST = 'setIsActiveRequest';
export const SET_USER_DATA = 'setUserData';
export const SET_USER_DASHBOARD = 'setUserDashboard';

// ACTIONS
export const ACTION_GET_USER_DATA = 'getUserData';
export const ACTION_GET_USERS = 'getUsers';
export const ACTION_ADD_USER = 'addUser';
export const ACTION_UPDATE_USER = 'updateUser';
export const ACTION_REMOVE_USER = 'removeUser';
export const ACTION_SHOW_MODAL = 'showModal';
export const ACTION_HIDE_MODAL = 'hideModal';
export const ACTION_EXPORT_USERS = 'exportUsers';
export const ACTION_IMPORT_USERS = 'importUsers';
export const ACTION_GET_USER_DASHBOARD = 'getUserDashboard';

// GETTERS
export const GET_SELECTED_USER = 'selectedUser';
export const GET_IS_LOADING = 'isLoading';
export const GET_IS_ACTIVE_REQUEST = 'isActiveRequest';
export const GET_IS_MODAL_VISIBLE = 'isModalVisible';
export const GET_USER_DATA = 'userData';
export const GET_USER_DASHBOARD = 'userDashboard';